"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IgRepostIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.006 15.769a.944.944 0 001.238 0 .735.735 0 000-1.116l-1.507-1.357h3.888c1.285 0 2.173-.5 2.71-1.173a3.082 3.082 0 00.665-1.87V7.1c0-.436-.392-.79-.875-.79s-.875.354-.875.79v3.155c0 .249-.09.64-.335.947-.213.266-.575.517-1.29.517H6.737l1.507-1.357a.735.735 0 000-1.116.944.944 0 00-1.238 0l-2.293 2.067c-.732.66-.732 1.73 0 2.39l2.293 2.067zM3.5 5.746c0-.249.09-.64.335-.947.213-.267.575-.517 1.29-.517h3.888L7.506 5.639a.735.735 0 000 1.116.944.944 0 001.238 0l2.293-2.067c.732-.66.732-1.73 0-2.39L8.744.23a.944.944 0 00-1.238 0 .735.735 0 000 1.115l1.507 1.358H5.125c-1.285 0-2.173.5-2.71 1.173a3.082 3.082 0 00-.665 1.87V8.9c0 .436.392.79.875.79s.875-.354.875-.79V5.746z",
    clipRule: "evenodd"
  })))
});
IgRepostIcon.displayName = 'IgRepostIcon';
var _default = exports.default = IgRepostIcon;